import React, { Component } from 'react';
import { Modal, Panel, Col, ButtonToolbar, Button } from 'react-bootstrap';

import { PropTypes } from 'prop-types';

import { LayoutDesign } from './LayoutDesign';
import { LayoutsTable } from './LayoutsTable';
import { LayoutCommand } from '../commands/LayoutCommand';
import { LayoutFormatHelper } from '../helpers/LayoutFormatHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SmoothDeslocationHelper } from '../../helpers/SmoothDeslocationHelper';
import { ComponentConvertHelper } from '../helpers/ComponentConvertHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { ImportLayoutConfigurationForm } from './ImportLayoutConfigurationForm';
import { geometry } from '@turf/turf';

export class LayoutConfigurations extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
    }

    constructor(props) {
        super(props);
        this.state = {
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            },
            operation: {
                message: <LoadingSpinner />,
                style: "primary",
                icon: "transfer",
                title: "A Executar..."
            },
            showImportLayoutForm: false,
            unmodifiedLayout: {
                id: 0,
                name: "",
                width: 2100,
                height: 2970,
                components: [],
                canvas: {
                    width: 500,
                    height: 300,
                    dimentionsRatio: 1
                }
            },
            layout: {
                isVisible: false,
                toInitialState: true,
                isOver: false,
                isNewComponent: false,
                nextInternalId: 1,
                id: 0,
                name: "",
                width: 2100,
                height: 2970,
                components: []
            },
            selectedComponent: {
                id: 0,
                internalId: undefined,
                modified: false,
                selectedGeometryIndex: 0,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            componentsStyle: {
                notes: {
                    type: "Notes",
                    color: "#C1D3DD",
                    text: "Observações"
                },
                simpleText: {
                    type: "SimpleText",
                    color: "#F5FAFC",
                    text: "Texto"
                },
                image: {
                    type: "Image",
                    color: "#EBF5FA",
                    text: "Imagem"
                },
                qrCode: {
                    type: "QrCode",
                    color: "#EFF5FA",
                    text: "QR Code"
                },
                dayTimesheet: {
                    type: "DayTimesheet",
                    color: "#DCEEF6",
                    text: "Horário"
                },
                compactDayTimesheet: {
                    type: "CompactDayTimesheet",
                    color: "#DCEEF6",
                    text: "Horário [Compacto]"
                },
                dayVerticalTimesheet: {
                    type: "DayVerticalTimesheet",
                    color: "#DCEEF6",
                    text: "Horário [Vertical]"
                },
                verticalDayTimesheet: {
                    type: "VerticalDayTimesheet",
                    color: "#DCEEF6",
                    text: "Horário [Lista]"
                },
                horizontalTabularDayTimesheet: {
                    type: "HorizontalTabularDayTimesheet",
                    color: "#DCEEF6",
                    text: "Horário [Tabular Hor.]"
                },
                verticalComposedDayTimesheet: {
                    type: "VerticalComposedDayTimesheet",
                    color: "#DCEEF6",
                    text: "Multi Horário [Vert.]"
                },
                verticalTabularDayTimesheet: {
                    type: "VerticalTabularDayTimesheet",
                    color: "#DCEEF6",
                    text: "Horário [Tabular Vert.]"
                },
                horizontalStopsList: {
                    type: "HorizontalStopsList",
                    color: "#9BCEE6",
                    text: "Espinha [Hor.]"
                },
                verticalStopsList: {
                    type: "VerticalStopsList",
                    color: "#9BCEE6",
                    text: "Espinha [Vert.]"
                },
                stopInformation: {
                    type: "StopInformation",
                    color: "#ABABAB",
                    text: "Info Paragem"
                },
                lineInformation: {
                    type: "LineInformation",
                    color: "#D0D0D0",
                    text: "Info Linha"
                },
                separator: {
                    type: "Separator",
                    color: "#DDDDDD",
                    text: "Separador"
                },
                exceptions: {
                    type: "Exceptions",
                    color: "#C3E2F0",
                    text: "Excepções"
                },
            },
            canvas: {
                width: 500,
                height: 300,
                dimentionsRatio: 1
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10,
                filter: ""
            },
            actions: {
                isLoading: true,
                isSaving: false,
                isDeleting: false
            },
            log: [],
            inputNameStyle: null
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions, table } = this.state;

            actions.isLoading = true;
            table.data = [];

            this.setState({
                table: table,
                actions: actions
            });
        }

        const layoutCommand = new LayoutCommand();
        layoutCommand.list(
            (a) => this.getAllSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ---------------------------

    getAllSuccessCallback(result) {
        const { table, actions } = this.state;

        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        table.data = result.map(r => Object.assign({
            format: LayoutFormatHelper.getFormatFromDimentions(r.width, r.height),
            orientation: LayoutFormatHelper.getOrientationFromDimentions(r.width, r.height)
        }, r));
        actions.isLoading = false;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    saveSuccessCallback(result) {
        const { componentsStyle, layout, canvas, actions } = this.state;

        const components = [];
        let internalId = layout.nextInternalId;

        for (const idx in result.components) {
            let typeLowerCase = result.components[idx].type;
            typeLowerCase = typeLowerCase.slice(0, 1).toLowerCase().concat(typeLowerCase.slice(1));

            const componentStyle = {
                color: "white",
                text: ""
            };

            if (undefined !== componentsStyle[typeLowerCase]) {
                componentStyle.color = componentsStyle[typeLowerCase].color;
                componentStyle.text = componentsStyle[typeLowerCase].text;
            }

            components.push(ComponentConvertHelper.convertToCanvas(result.components[idx],
                internalId++,
                componentStyle.color,
                componentStyle.text,
                canvas.dimentionsRatio));
        }
        layout.toInitialState = true;
        layout.id = result.id;
        layout.nextInternalId = internalId;
        layout.components = components;

        actions.isSaving = false;

        this.setState({
            layout: layout,
            unmodifiedLayout: {
                id: layout.id,
                name: layout.name,
                width: layout.width,
                height: layout.height,
                components: layout.components.slice(0).map(component => Object.assign({}, component)),
                canvas: Object.assign({}, canvas)
            },
            selectedComponent: {
                id: 0,
                internalId: undefined,
                selectedGeometryIndex: 0,
                modified: false,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            message: {
                show: true,
                message: "Layout gravado com sucesso",
                style: "success",
                title: "Sucesso",
                icon: "ok"
            },
            actions: actions,
            log: []
        });

        this.getAllData(true);
    }

    deleteSuccessCallback(layoutId, message) {
        const { layout, actions } = this.state;

        let selectedLayout = layout;
        if (layoutId === layout.id) {
            selectedLayout = {
                isVisible: false,
                toInitialState: true,
                isOver: false,
                isNewComponent: false,
                nextInternalId: 1,
                id: 0,
                name: "",
                width: 2100,
                height: 2970,
                components: []
            }
        }

        actions.isDeleting = false;

        this.setState({
            layout: selectedLayout,
            selectedComponent: {
                internalId: undefined,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            canvas: this.getNewCanvas(selectedLayout.width, selectedLayout.height),
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            },
            actions: actions,
            log: []
        });

        this.getAllData(true);
    }

    listErrorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationsErrorCallback(message) {
        const { actions } = this.state;

        actions.isSaving = false;
        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        this.getAllData(true);
    }

    // -----------------------

    getNewCanvas(layoutWidth, layoutHeight) {
        const { canvas } = this.state;
        const newCanvas = {
            width: canvas.width,
            height: 100,
            dimentionsRatio: 1
        }

        const dimentionsRatio = newCanvas.width / layoutWidth;
        newCanvas.height = layoutHeight * dimentionsRatio;
        newCanvas.dimentionsRatio = dimentionsRatio;

        return newCanvas;
    }

    resetLayout() {
        const { layout, unmodifiedLayout } = this.state;

        layout.toInitialState = true;
        layout.id = unmodifiedLayout.id;
        layout.name = unmodifiedLayout.name;
        layout.width = unmodifiedLayout.width;
        layout.height = unmodifiedLayout.height;
        layout.components = unmodifiedLayout.components.slice(0).map(component => Object.assign({}, component));

        this.setState({
            layout: layout,
            canvas: Object.assign({}, unmodifiedLayout.canvas),
            selectedComponent: {
                id: 0,
                internalId: undefined,
                modified: false,
                selectedGeometryIndex: 0,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            log: []
        });
    }

    newLayout(goToWorkspace) {
        this.setState({
            unmodifiedLayout: {
                id: 0,
                name: "",
                width: 2100,
                height: 2970,
                components: [],
                canvas: {
                    width: 500,
                    height: 300,
                    dimentionsRatio: 1
                }
            },
            layout: {
                isVisible: true,
                toInitialState: true,
                isOver: false,
                isNewComponent: false,
                nextInternalId: 1,
                id: 0,
                name: "",
                width: 2100,
                height: 2970,
                components: []
            },
            selectedComponent: {
                id: 0,
                internalId: undefined,
                modified: false,
                selectedGeometryIndex: 0,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            canvas: this.getNewCanvas(2100, 2970),
            log: [],
            inputNameStyle: null
        }, () => {
            if (goToWorkspace) {
                SmoothDeslocationHelper.goToPostitionFromTop(document.getElementById("workspace").offsetTop, 500);
            }
        });
    }

    resetComponentsDrawPositions(layoutComponents, dimentionsRatio) {
        const components = layoutComponents.slice(0).map(c => Object.assign({}, c));

        for (const idx in components) {
            components[idx].geometries = components[idx].geometries.map(geometry => ({
                ...geometry,
                drawPositionX: geometry.absolutePositionAxisX * dimentionsRatio + 5,
                drawPositionY: geometry.absolutePositionAxisY * dimentionsRatio + 5,
                offsetX: 0,
                offsetY: 0
            }))
        }

        return components;
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const layoutCommand = new LayoutCommand();

            switch (argument.operation) {
                case "delete-layout":
                    actions.isDeleting = true;

                    layoutCommand.delete(
                        argument.layoutId,
                        (a, b) => this.deleteSuccessCallback(a, b),
                        (a) => this.operationsErrorCallback(a)
                    );
                    break;

                case "reset-layout":
                    this.resetLayout();
                    break;

                case "new-layout":
                    this.newLayout(false);
                    break;

                case "save-layout":
                    actions.isSaving = true;

                    layoutCommand.save(
                        this.state.layout,
                        (a) => this.saveSuccessCallback(a),
                        (a) => this.operationsErrorCallback(a)
                    );
                    break;
                default:
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            }
        }, async () => {
            if (isToExecute && "new-layout" === argument.operation) {
                SmoothDeslocationHelper.goToPostitionFromTop(document.getElementById("workspace").offsetTop, 500);
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    onEditLayout(layout) {
        const { componentsStyle } = this.state;
        const convertedLayout = {
            isVisible: true,
            toInitialState: true,
            isOver: false,
            isNewComponent: false,
            nextInternalId: 1,
            id: layout.id,
            name: layout.name,
            width: layout.width,
            height: layout.height,
            components: []
        };

        const canvas = this.getNewCanvas(convertedLayout.width, convertedLayout.height);

        let internalId = convertedLayout.nextInternalId;
        for (const idx in layout.components) {
            let typeLowerCase = layout.components[idx].type;
            typeLowerCase = typeLowerCase.slice(0, 1).toLowerCase().concat(typeLowerCase.slice(1));

            const componentStyle = {
                color: "white",
                text: ""
            };

            if (undefined !== componentsStyle[typeLowerCase]) {
                componentStyle.color = componentsStyle[typeLowerCase].color;
                componentStyle.text = componentsStyle[typeLowerCase].text;
            }

            convertedLayout.components.push(ComponentConvertHelper.convertToCanvas(layout.components[idx],
                internalId++,
                componentStyle.color,
                componentStyle.text,
                canvas.dimentionsRatio));
        }
        convertedLayout.nextInternalId = internalId;

        this.setState({
            layout: convertedLayout,
            unmodifiedLayout: {
                id: convertedLayout.id,
                name: convertedLayout.name,
                width: convertedLayout.width,
                height: convertedLayout.height,
                components: convertedLayout.components.slice(0).map(component => Object.assign({}, component)),
                canvas: Object.assign({}, canvas)
            },
            canvas: canvas,
            selectedComponent: {
                id: 0,
                internalId: undefined,
                modified: false,
                selectedGeometryIndex: 0,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: "",
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            log: [],
            inputNameStyle: null
        }, () => {
            SmoothDeslocationHelper.goToPostitionFromTop(document.getElementById("workspace").offsetTop, 500);
        });
    }

    onDeleteLayout(layout) {
        this.setState({
            dialog: {
                show: true,
                message: `Tem a certeza que pretende eliminar o layout "${layout.name}"?`,
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    layoutId: layout.id,
                    operation: "delete-layout"
                }
            }
        });
    }

    // -----------------------

    onCreateNewLayoutConfiguration() {
        const { layout } = this.state;

        if (layout.isVisible) {
            this.setState({
                dialog: {
                    show: true,
                    message: `Tem a certeza que cancelar todas as alterações efectuadas não guardadas ao layout e criar um novo layout?`,
                    style: "warning",
                    icon: "alert",
                    title: "Aviso",
                    argument: {
                        operation: "new-layout"
                    }
                }
            });
        }
        else {
            this.newLayout(true);
        }
    }

    onImportLayoutConfiguration() {
        this.setState({
            showImportLayoutForm: true
        });
    }

    onExitImportLayoutConfiguration(success, message) {
        if (undefined !== message && null !== message && "" !== message) {
            this.setState({
                message: {
                    show: true,
                    message: message,
                    style: success ? "success" : "danger",
                    title: success ? "Sucesso" : "Erro",
                    icon: success ? "ok" : "remove"
                }
            });
        }

        this.setState({
            showImportLayoutForm: !success
        });

        if(success) {
            this.getAllData(true);
        }
    }

    onSaveLayoutConfiguration() {
        const { log } = this.state;

        if(this.state.layout.name === ""){
            this.setState({
                inputNameStyle: "error",
                message: {
                    show: true,
                    message: "O campo nome é de preenchimento obrigatório.",
                    style: "danger",
                    icon: "remove",
                    title: "Erro",
                }
            });
            return;
        }

        const message = [];
        message.push(<p key="main-message"><b>Alterações efectuadas! Prentende continuar?</b></p>);
        log.map((l, i) => message.push(<li key={`log-${i}`}>{l}</li>));

        this.setState({
            dialog: {
                show: true,
                message: message,
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    operation: "save-layout"
                }
            }
        });
    }

    onCancelChangesLayoutConfiguration() {
        this.setState({
            dialog: {
                show: true,
                message: `Tem a certeza que cancelar todas as alterações efectuadas não guardadas ao layout?`,
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    operation: "reset-layout"
                }
            }
        });
    }

    onSaveLayoutProperties(layoutProperties) {
        const { layout, log } = this.state;

        const canvas = this.getNewCanvas(layoutProperties.width, layoutProperties.height);

        layout.name = layoutProperties.name;
        layout.width = layoutProperties.width;
        layout.height = layoutProperties.height;

        log.push(`Alteradas propriedades do layout: ${layout.name} | W: ${layout.width} | H: ${layout.height}`);

        layout.components = this.resetComponentsDrawPositions(layout.components, canvas.dimentionsRatio);

        this.setState({
            inputNameStyle: 0 >= layout.name.length ? "error" : null,
            layout: layout,
            canvas: canvas,
            log: log
        });
    }

    onSaveComponentProperties(componentProperties) {
        if (null === componentProperties.internalId || undefined === componentProperties.internalId) {
            return;
        }

        const { layout, canvas, selectedComponent, componentsStyle, log } = this.state;

        const components = layout.components.slice(0);
        const componentToUpdate = components.filter(function (c) {
            return c.internalId === componentProperties.internalId;
        })[0];
        const componentIdx = components.indexOf(componentToUpdate);

        components[componentIdx].geometries = componentProperties.geometries.map(g => ({
            ...g,
            absolutePositionAxisX: g.positionX,
            absolutePositionAxisY: g.positionY,
            drawPositionX: 5 + g.positionX * canvas.dimentionsRatio,
            drawPositionY: 5 + g.positionY * canvas.dimentionsRatio
        }));
        components[componentIdx].dataIdentifier = componentProperties.dataIdentifier;
        components[componentIdx].configuration = componentProperties.configuration;
        components[componentIdx].parameters = componentProperties.parameters;
        components[componentIdx].fonts = componentProperties.fonts.slice(0);
        components[componentIdx].backgrounds = componentProperties.backgrounds.slice(0);
        components[componentIdx].margins = componentProperties.margins.slice(0);
        components[componentIdx].circleElements = componentProperties.circleElements.slice(0);
        components[componentIdx].selectedGeometryIndex = componentProperties.selectedGeometryIndex;

        layout.components = components;
        selectedComponent.modified = false;

        const componentType = componentsStyle[componentProperties.type.slice(0, 1).toLowerCase().concat(componentProperties.type.slice(1))];
        const componentTypeText = undefined === componentType ? "" : componentType.text;
        log.push(`Alteradas propriedades do elemento "${componentTypeText}": 
                        W: ${componentProperties.geometries[0].width} | H: ${componentProperties.geometries[0].height} | 
                        Px: ${componentProperties.geometries[0].positionX} | Py: ${componentProperties.geometries[0].positionY}`);

        this.setState({
            layout: layout,
            selectedComponent: selectedComponent,
            log: log
        });
    }

    onDeleteSelectedComponent(component) {
        if (null === component.internalId || undefined === component.internalId) {
            return;
        }

        const { layout, componentsStyle, log } = this.state;

        const components = layout.components.slice(0).filter(function (c) {
            return c.internalId !== component.internalId;
        });

        layout.components = components;

        const componentType = componentsStyle[component.type.slice(0, 1).toLowerCase().concat(component.type.slice(1))];
        const componentTypeText = undefined === componentType ? "" : componentType.text;
        log.push(`Eliminado o elemento "${componentTypeText}"`);

        this.setState({
            layout: layout,
            selectedComponent: {
                id: 0,
                internalId: undefined,
                modified: false,
                selectedGeometryIndex: 0,
                geometries: [{
                    width: "",
                    height: "",
                    positionX: "",
                    positionY: "",
                    positionZ: ""
                }],
                dataIdentifier: "",
                configuration: "",
                parameters: null,
                type: "",
                fonts: [],
                backgrounds: [],
                margins: [],
                circleElements: []
            },
            log: log
        });
    }

    // -----------------------

    onSelectedComponentChangeValue(e, target) {
        const { layout, selectedComponent } = this.state;

        selectedComponent[target] = e.target.value;
        selectedComponent.modified = true;

        // Validation to prevent the component going out of the layout
        // Ensure that width, height, positionAxisX and positionAxisX are treated as numbers
        selectedComponent.geometries = selectedComponent.geometries.map((g) => {
            let width = parseInt(`${g.width}`, 10);
            let height = parseInt(`${g.height}`, 10);
            let positionX = parseInt(`${g.positionX}`, 10);
            let positionY = parseInt(`${g.positionY}`, 10);

            if (width < 1) {
                width = 1;
            }
            else if (width > layout.width) {
                width = layout.width;
            }

            if (height < 1) {
                height = 1;
            }
            else if (height > layout.height) {
                height = layout.height;
            }

            if (positionX < 0) {
                positionX = 0;
            }
            else if (positionX + width > layout.width) {
                positionX = layout.width - width;
            }

            if (positionY < 0) {
                positionY = 0;
            }
            else if (positionY + height > layout.height) {
                positionY = layout.height - height;
            }

            return {
                ...g,
                width,
                height,
                positionX,
                positionY
            };
        });

        this.setState({
            selectedComponent: selectedComponent
        }, () => {
            this.onSaveComponentProperties(selectedComponent);
        });
    }

    onComponentClick(componentInternalId, geometryIndex) {
        const { layout } = this.state;
        const components = layout.components.slice(0);
        const selectedComponent = components.find((c) => c.internalId === componentInternalId);

        if (undefined === selectedComponent) {
            return;
        }

        this.setState({
            selectedComponent: {
                id: selectedComponent.id,
                internalId: selectedComponent.internalId,
                modified: selectedComponent.modified,
                selectedGeometryIndex: geometryIndex,
                geometries: selectedComponent.geometries.map(g => ({
                    width: g.width,
                    height: g.height,
                    positionX: g.absolutePositionAxisX,
                    positionY: g.absolutePositionAxisY,
                    positionZ: g.positionZ,
                    offsetX: g.offsetX,
                    offsetY: g.offsetY
                })),
                dataIdentifier: selectedComponent.dataIdentifier,
                configuration: selectedComponent.configuration,
                parameters: selectedComponent.parameters,
                type: selectedComponent.type,
                fonts: undefined === selectedComponent.fonts ? [] : selectedComponent.fonts.map(font => Object.assign({}, font)),
                backgrounds: undefined === selectedComponent.backgrounds ? [] : selectedComponent.backgrounds.map(background => Object.assign({}, background)),
                margins: undefined === selectedComponent.margins ? [] : selectedComponent.margins.map(margin => Object.assign({}, margin)),
                circleElements: undefined === selectedComponent.circleElements ? [] : selectedComponent.circleElements.map(circleElement => Object.assign({}, circleElement))
            }
        });
    }

    // -----------------------

    onMoveExistingComponent(e, component, geometryIndex = 0) {
        const { layout, canvas, selectedComponent, componentsStyle, log } = this.state;

        const components = layout.components.slice(0);
        const componentToUpdate = components.find(c => c.internalId === component.internalId);
        const componentIdx = components.indexOf(componentToUpdate);

        // Get initial position (components[componentIdx].drawPositionX - components[componentIdx].offsetX) and add the total deslocation
        // The value 5 is the margin between the stage and the white rectangle
        const startPosition = {
            x: (components[componentIdx].geometries[geometryIndex].drawPositionX - components[componentIdx].geometries[geometryIndex].offsetX + e.target.x() - 5) / canvas.dimentionsRatio,
            y: (components[componentIdx].geometries[geometryIndex].drawPositionY - components[componentIdx].geometries[geometryIndex].offsetY + e.target.y() - 5) / canvas.dimentionsRatio
        }

        let positionXOffset = 0;
        if (0 > startPosition.x) {
            positionXOffset = (5 - startPosition.x) * canvas.dimentionsRatio;
            startPosition.x = 0;
        }
        else if (layout.width < startPosition.x + components[componentIdx].geometries[geometryIndex].width) {
            positionXOffset = (startPosition.x + components[componentIdx].geometries[geometryIndex].width - layout.width) * -canvas.dimentionsRatio;
            startPosition.x = layout.width - components[componentIdx].geometries[geometryIndex].width;
        }

        let positionYOffset = 0;
        if (0 > startPosition.y) {
            positionYOffset = (5 - startPosition.y) * canvas.dimentionsRatio;
            startPosition.y = 0;
        }
        else if (layout.height < startPosition.y + components[componentIdx].geometries[geometryIndex].height) {
            positionYOffset = (startPosition.y + components[componentIdx].geometries[geometryIndex].height - layout.height) * -canvas.dimentionsRatio;
            startPosition.y = layout.height - components[componentIdx].geometries[geometryIndex].height;
        }

        components[componentIdx].geometries[geometryIndex].absolutePositionAxisX = startPosition.x;
        components[componentIdx].geometries[geometryIndex].absolutePositionAxisY = startPosition.y;
        components[componentIdx].geometries[geometryIndex].drawPositionX += e.target.x() + positionXOffset;
        components[componentIdx].geometries[geometryIndex].drawPositionY += e.target.y() + positionYOffset;
        components[componentIdx].geometries[geometryIndex].offsetX = e.target.offsetX();
        components[componentIdx].geometries[geometryIndex].offsetY = e.target.offsetY();

        // Update selected component
        if (components[componentIdx].internalId === selectedComponent.internalId) {
            selectedComponent.geometries[geometryIndex].positionX = components[componentIdx].geometries[geometryIndex].absolutePositionAxisX;
            selectedComponent.geometries[geometryIndex].positionY = components[componentIdx].geometries[geometryIndex].absolutePositionAxisY;
        }

        layout.toInitialState = false;
        layout.components = components;

        selectedComponent.selectedGeometryIndex = geometryIndex;

        const componentType = componentsStyle[component.type.slice(0, 1).toLowerCase().concat(component.type.slice(1))];
        if (undefined !== componentType) {
            log.push(`Movido o elemento "${componentType.text}":  
                        Px: ${startPosition.x} | Py: ${startPosition.y}`);
        }

        this.setState({
            layout: layout,
            selectedComponent: selectedComponent,
            log: log
        });
    }

    onHitLayout(e) {
        const { layout, canvas, componentsStyle, log } = this.state;

        if (layout.isOver && layout.isNewComponent) {
            const { dragData, dragElem } = e;

            const dragDataRealPostion = {
                x: dragElem.getBoundingClientRect().x - (e.x - dragData.geometries[0].positionAxisX),
                y: dragElem.getBoundingClientRect().y - (e.y - dragData.geometries[0].positionAxisY)
            };

            // Sometimes the position is not received
            if (isNaN(dragDataRealPostion.x)) {
                dragDataRealPostion.x = 0;
            }

            if (isNaN(dragDataRealPostion.y)) {
                dragDataRealPostion.y = 0;
            }

            const component = {
                id: dragData.id,
                internalId: layout.nextInternalId,
                type: dragData.type,
                text: dragData.text,
                geometries: [{ 
                    width: dragData.defaultWidth,
                    height: dragData.defaultHeight,
                    absolutePositionAxisX: dragDataRealPostion.x / canvas.dimentionsRatio,
                    absolutePositionAxisY: dragDataRealPostion.y / canvas.dimentionsRatio,
                    drawPositionX: dragDataRealPostion.x + 5,
                    drawPositionY: dragDataRealPostion.y + 5,
                    offsetX: 0,
                    offsetY: 0
                }],
                dataIdentifier: dragData.dataIdentifier,
                configuration: dragData.configuration,
                parameters: dragData.parameters,
                color: dragData.color,
                fonts: [],
                backgrounds: [],
                circleElements: []
            };
            const components = layout.components.slice(0);
            components.push(component);

            layout.toInitialState = false;
            layout.isNewComponent = false;
            layout.nextInternalId = layout.nextInternalId + 1;
            layout.components = components;

            const componentTypeText = componentsStyle[component.type.slice(0, 1).toLowerCase().concat(component.type.slice(1))].text;
            log.push(`Adicionado o elemento "${componentTypeText}":  
                            Px: ${component.absolutePositionAxisX} | Py: ${component.absolutePositionAxisY}`);

            this.setState({
                layout: layout,
                log: log
            });
        }
    }

    onDragEnterMethod(_) {
        const { layout } = this.state;

        layout.toInitialState = false;
        layout.isOver = true;
        layout.isNewComponent = true;

        this.setState({
            layout: layout
        });
    }

    onDragLeaveMethod(_) {
        const { layout } = this.state;

        layout.toInitialState = false;
        layout.isOver = false;
        layout.isNewComponent = false;

        this.setState({
            layout: layout
        });
    }

    // -----------------------

    onResizeWorkspace(width, _) {
        const { layout } = this.state;

        if (450 < width) {
            width = 450;
        }

        const dimentionsRatio = width / layout.width;
        const components = layout.components.slice(0).map(c => Object.assign({}, c));

        for (const idx in components) {
            components[idx].drawPositionX = components[idx].absolutePositionAxisX * dimentionsRatio + 5;
            components[idx].drawPositionY = components[idx].absolutePositionAxisY * dimentionsRatio + 5;
            components[idx].offsetX = 0;
            components[idx].offsetY = 0;
        }

        layout.components = this.resetComponentsDrawPositions(layout.components, dimentionsRatio);

        this.setState({
            layout: layout,
            canvas: {
                dimentionsRatio: dimentionsRatio,
                width: width,
                height: layout.height * dimentionsRatio
            }
        });
    }

    // -----------------------

    renderImportLayoutConfigurationForm() {
        const { showImportLayoutForm } = this.state;

        if (!showImportLayoutForm) {
            return null;
        }

        return (
            <Modal show={true} >
                <Modal.Body className="padding-0" >
                    <Panel className="margin-bottom-0 border-0">
                        <Panel.Heading>
                            <h3 className="alert-title">Importar Layout</h3>
                        </Panel.Heading>

                        <Panel.Body>
                            <ImportLayoutConfigurationForm
                                exit={(a, b) => this.onExitImportLayoutConfiguration(a, b)} />
                        </Panel.Body>
                    </Panel>
                </Modal.Body>
            </Modal>
        );
    }

    renderLayoutDesign(layout, canvas, componentsStyle, selectedComponent, inputNameStyle) {
        if (!layout.isVisible) {
            return <div>&nbsp;</div>;
        }

        return (
            <LayoutDesign
                layout={layout}
                canvas={canvas}
                inputNameStyle={inputNameStyle}
                componentsStyle={componentsStyle}
                selectedComponent={selectedComponent}
                onDragEnter={(a) => this.onDragEnterMethod(a)}
                onDragLeave={(a) => this.onDragLeaveMethod(a)}
                onHitLayout={(a) => this.onHitLayout(a)}
                onMoveExistingComponent={(a, b, c) => this.onMoveExistingComponent(a, b, c)}
                onResize={(a, b) => this.onResizeWorkspace(a, b)}
                onComponentClick={(a, b) => this.onComponentClick(a, b)}
                onDeleteSelectedComponent={(a) => this.onDeleteSelectedComponent(a)}
                onSelectedComponentChangeValue={(a, b) => this.onSelectedComponentChangeValue(a, b)}
                onSaveLayoutProperties={(a) => this.onSaveLayoutProperties(a)}
                onSaveLayoutConfiguration={() => this.onSaveLayoutConfiguration()}
                onCancelChangesLayoutConfiguration={() => this.onCancelChangesLayoutConfiguration()} />
        );
    }

    render() {
        const { layout, table, canvas, selectedComponent, componentsStyle, actions, message, dialog, operation, inputNameStyle } = this.state;

        return (
            <div>
                <TitleRow title="Layouts" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateNewLayoutConfiguration()}>NOVO</Button>
                            <Button onClick={() => this.onImportLayoutConfiguration()}>CARREGAR</Button>
                        </ButtonToolbar>
                    </Col>

                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <LayoutsTable
                    table={table}
                    isLoading={actions.isLoading}
                    onChangePage={(a, b) => this.onChangePage(a, b)}
                    onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)}
                    tableHeight={table.height}
                    onEditLayout={(a) => this.onEditLayout(a)}
                    onDeleteLayout={(a) => this.onDeleteLayout(a)} />

                <section id="workspace">
                    {this.renderLayoutDesign(layout, canvas, componentsStyle, selectedComponent, inputNameStyle)}
                </section>

                {this.renderImportLayoutConfigurationForm()}

                <HandleDialog
                    title={dialog.title}
                    message={dialog.message}
                    argument={dialog.argument}
                    style={dialog.style}
                    icon={dialog.icon}
                    show={dialog.show}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
                <HandleMessage
                    title={operation.title}
                    message={operation.message}
                    style={operation.style}
                    icon={operation.icon}
                    show={actions.isSaving || actions.isDeleting}
                    small
                    noButtons />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/LayoutConfigurations.js